import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { ErrorMessage } from '../validation/validationError';
import { ZodError } from 'zod';
import { studentLocationFormValidation, studentLocationUsingDeviceIdFormValidation } from '../validation/Validation';
import { Loader } from '../components/ModalsCommonFunctions';
import GetAddress from '../components/GetAddress';

const StudentLocation = () => {
  const authorizedAxios = generateAxiosInstance();
  const authorizedAxiosSection = generateAxiosInstanceSection()
  const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
  const authorizedAxiosCommon = generateAxiosInstanceCommon()
  const initialFormState = {
    instituteMasterId: '',
    sectionMasterId: '',
    academicYearMasterId: '',
    instituteGradeMasterId: '',
    instituteDivisionMasterId: '',
    isDevice: true,
    studentId: '',
    deviceId: ''
  }

  const [studentData, setStudentData] = useState(initialFormState);
  const [instituteList, setInstituteList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [academicYearList, setAcademicYearList] = useState([]);
  const [gradeList, setGradeList] = useState([])
  const [divisionList, setDivisionList] = useState([])
  const [studentList, setStudentList] = useState([])
  const [isLocation, setIsLocation] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [error, setError] = useState([])
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleNavigate = (route) => {
    navigate(route);
  };

  useEffect(() => {
    getInstituteList();
  }, []);

  const getInstituteList = () => {
    const apiUrlForInstituteList = `/get-institute-master`;
    authorizedAxios && authorizedAxios.get(apiUrlForInstituteList)
      .then(response => {
        setInstituteList(response.data.result);
      })
      .catch(error => {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      })
  }

  const handleInsituteChange = (e) => {
    const { name, value } = e.target;
    setStudentData(prevData => {
      return {
        ...prevData,
        [name]: value,
      }
    })

    setSectionList([]);

    const apiUrl = `/get-section?instituteMasterId=${value}`;
    authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
      .then(response => {
        setSectionList(response.data.result)
      })
      .catch(error => {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      });

    if (value.trim().length !== 0) {
      setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const handleSectionChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prevData) => {
      return {
        ...prevData,
        [name]: value,
        academicYearMasterId: ''
      }
    })

    const apiUrl1 = `/sections-academic-years?sectionMasterId=${value}`;
    authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl1)
      .then(response => {
        setAcademicYearList(response.data.data)
      })
      .catch(error => {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      });

    if (value.trim().length !== 0) {
      setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const handleAcademicYearChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prevData) => {
      return {
        ...prevData,
        [name]: value
      }
    })

    const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${studentData.instituteMasterId}`;
    authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
      .then(response => {
        setGradeList(response.data.result)
      })
      .catch(error => {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      });

    if (value.trim().length !== 0) {
      setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const handleGradeChange = (e) => {
    const { name, value } = e.target;
    setStudentData(prevData => {
      return {
        ...prevData,
        [name]: value,
        instituteDivisionMasterId: '',
        studentId: '',
      }
    })

    const apiUrl = `/grade-wise-division?instituteMasterId=${studentData.instituteMasterId}&instituteGradeMasterId=${value}`;
    authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
      .then(response => {
        setDivisionList(response.data.result)
      })
      .catch(error => {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      });

    if (value.trim().length !== 0) {
      setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const handleDivisionChange = (e) => {
    const { name, value } = e.target;
    setStudentData(prevData => {
      return {
        ...prevData,
        [name]: value,
        studentId: ''
      }
    })

    // const apiUrl = `/get-student-details-report?instituteMasterId=${studentData.instituteMasterId}&sectionMasterId=${studentData.sectionMasterId}&academicYearMasterId=${studentData.academicYearMasterId}&instituteGradeMasterId=${studentData.instituteGradeMasterId}&instituteDivisionMasterId=${value}`;

    const apiUrl = `students?instituteMasterId=${studentData.instituteMasterId}&sectionMasterId=${studentData.sectionMasterId}&year=${studentData.academicYearMasterId}&gradeId=${studentData.instituteGradeMasterId}&divisionId=${value}`;
    authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
      .then(response => {
        setStudentList(response.data.result.rows)
      })
      .catch(error => {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.log(errorMsg);
      });

    if (value.trim().length !== 0) {
      setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'isDevice') {
      setStudentData(prevData => {
        return {
          ...prevData,
          [name]: value === "true"
        }
      })
    } else {
      setStudentData(prevState => {
        return {
          ...prevState,
          [name]: value
        }
      });
    }

    if (value.trim().length !== 0) {
      setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const requestLocation = async () => {
    try {
      if (studentData.isDevice === false) {
        await studentLocationFormValidation.parseAsync(studentData);
      } else {
        await studentLocationUsingDeviceIdFormValidation.parseAsync(studentData);
      }
      setError([]);
      setLoading(true);

      let response;
      if(studentData.isDevice) {
        const apiUrl = `/send-device-notification?device_id=${studentData.deviceId}`;
        response = await authorizedAxiosCommon.get(apiUrl);
      } else {
        const apiUrl = `/send-student-notification?userUniqueId=${studentData.studentId}`;
        response = await authorizedAxiosSection.get(apiUrl);
      }

      const message = response.data.message;
      setIsLocation(message !== "User not logged in");
      
      Swal.fire({ text: message });
    } catch (error) {
      if (error instanceof ZodError) {
        setError(error.errors);
      } else {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        setIsLocation(errorMsg !== "User not logged in");
        Swal.fire({ text: errorMsg });
      }
    } finally {
      setResetTrigger(prev => !prev);
      setLoading(false);
    }
  }

  const handleInputResetStudent = () => {
    setSectionList([]);
    setAcademicYearList([]);
    setGradeList([]);
    setDivisionList([]);
    setStudentList([]);
    setStudentData(prevData => ({
      ...prevData,
      instituteMasterId: '',
      sectionMasterId: '',
      academicYearMasterId: '',
      instituteGradeMasterId: '',
      instituteDivisionMasterId: '',
      studentId: ''
    }));
    setError([]);
  }

  const handleInputResetDevice = () => {
    setSectionList([]);
    setAcademicYearList([]);
    setGradeList([]);
    setDivisionList([]);
    setStudentList([]);
    setStudentData(prevData => ({
      ...prevData,
      deviceId: ''
    }));
    setError([]);
  }

  return (
    <>
      <Loader loading={loading} />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <div id='scroll-up'></div>
        <Header />
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb my-0 ms-2">
            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
              <span>Dashboard</span>
            </li>
            <li className="breadcrumb-item active"><span>Student Location</span></li>
          </ol>
        </nav>
        <div className="container-lg">
          <div className="row">
            <div className="card border-info mx-auto mt-3">
              <div className="card-content collpase show">
                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                  <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-map-marker"></i>Student Location</b></h4>
                </div>
                <div className="card-body ">
                  <div className="row">
                    <div className="col-md-12">

                      <div className="col-md-12 view_content_radio_btn">
                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Using Device Id or Student :</label>
                        <label>
                          <input type="radio" name="isDevice" value={true} checked={studentData.isDevice === true} onChange={handleInputChange} /> &nbsp;Device
                        </label>
                        <label>
                          <input type="radio" name="isDevice" value={false} checked={studentData.isDevice === false} onChange={handleInputChange} /> &nbsp;Student
                        </label>
                      </div>

                      {studentData.isDevice === false &&
                        <>
                          <div className="row">
                            <div className="col-md-6">
                              <label for="instituteMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Institute :</label>
                              <select class="form-select" aria-label="Default select example" name='instituteMasterId' onChange={handleInsituteChange} value={studentData.instituteMasterId} >
                                <option selected value={''} disabled>Select Institute</option>
                                {
                                  instituteList?.map((institute) => {
                                    return <option value={institute.id}>{institute.instituteName}</option>
                                  })
                                }
                              </select>
                              <ErrorMessage errors={error} field="instituteMasterId" />
                            </div>
                            <div className="col-md-6">
                              <label for="sectionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Section :</label>
                              <select class="form-select" aria-label="Default select example" name='sectionMasterId' onChange={handleSectionChange} value={studentData.sectionMasterId} >
                                <option selected value={''} disabled>Select Section</option>
                                {
                                  sectionList?.map((section) => {
                                    return <option value={section.id}>{section.sectionName}</option>
                                  })
                                }
                              </select>
                              <ErrorMessage errors={error} field="sectionMasterId" />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <label for="academicYearMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Academic Year :</label>
                              <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleAcademicYearChange} value={studentData.academicYearMasterId}>
                                <option selected value={''} disabled>Select Year</option>
                                {
                                  academicYearList?.map((year) => {
                                    return <option value={year.academicYearMasterId}>{year.academicYearMasterDetails.yearName}</option>
                                  })
                                }
                              </select>
                              <ErrorMessage errors={error} field="academicYearMasterId" />
                            </div>

                            <div className="col-md-6">
                              <label for="instituteGradeMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                              <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={studentData.instituteGradeMasterId}>
                                <option selected value={''} disabled>Select Class :</option>
                                {
                                  gradeList?.map((grade) => {
                                    return <option value={grade.id}>{grade.gradeName}</option>
                                  })
                                }
                              </select>
                              <ErrorMessage errors={error} field="instituteGradeMasterId" />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <label for="instituteDivisionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                              <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleDivisionChange} value={studentData.instituteDivisionMasterId}>
                                <option selected value={''} disabled>Select Division</option>
                                {
                                  divisionList?.map((division) => {
                                    return <option value={division.id}>{division.divisionName}</option>
                                  })
                                }
                              </select>
                              <ErrorMessage errors={error} field="instituteDivisionMasterId" />
                            </div>

                            <div className="col-md-6">
                              <label for="studentId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Student :</label>
                              <select class="form-select" aria-label="Default select example" name='studentId' onChange={handleInputChange} value={studentData.studentId}>
                                <option selected value={''} disabled>Select Student</option>
                                {
                                  studentList?.map((student) => {
                                    if(student.isActive) {
                                      return <option value={student.studentId}>{student.studentName}</option>
                                    }
                                  })
                                }
                              </select>
                              <ErrorMessage errors={error} field="studentId" />
                            </div>
                          </div>
                        </>}

                      {studentData.isDevice === true &&
                        <div className='col-md-6'>
                          <label for="deviceId" className='col-form-label'><span style={{ color: "red" }}>*</span>Enter Device Id :</label>
                          <input className="form-control" type="text" name='deviceId' value={studentData.deviceId} onChange={handleInputChange} />

                          <ErrorMessage errors={error} field="deviceId" />
                        </div>}

                      <div className="row">
                        <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                          <div className="col-auto">
                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={requestLocation} >Request</button>
                            <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={studentData.isDevice ? handleInputResetDevice : handleInputResetStudent}>Reset</button>
                          </div>
                        </div>

                        {isLocation && <>
                          <div className="separator"></div>
                          <div className="d-grid gap-2 mt-2">
                            <GetAddress isDevice={studentData.isDevice} uniqueId={studentData.isDevice ? studentData.deviceId : studentData.studentId} resetTrigger={resetTrigger} />
                          </div>
                        </>}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
};

export default StudentLocation;